import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CallHistoryMentee from './CallHistoryMentee'
import OverviewMentee from './OverviewMentee';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import { useDispatch, useSelector } from 'react-redux';
import { adminData, clearState, getFeedbackAnswers, getMenteeCallsActivity, getMenteePerformance, getParticularUser, getPastInterviewDetails, getUpcomingInterviewDetails, updateSpecificUser } from '../../../reducer/adminSlice';
import AdviewCallhistory from '../../../components/Popups/ViewCallDetails/AdviewCallhistory';
import moment from 'moment';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import SuccessToast from '../../../components/Toast/SuccessToast';
import ErrorToast from '../../../components/Toast/ErrorToast';
import Skeleton from 'react-loading-skeleton';

function AdMenteeProfile() {

    //View call details states
    const [viewCallDetails, setViewCallDetails ] = useState(false);
    const [menteeFeedback, setMenteeFeedback] = useState({});
    const [mentorFeedback, setMentorFeedback] = useState({});

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalUpcomingCalls, setTotalUpcomingcalls] = useState([]);
    const [totalPastCalls, setTotalPastCalls] = useState([]);

    //Search states
    const [search, setSearch] = useState("");

    //Filter states
    const [program, setProgram] = useState("");
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("");

    //Edit credits
    const [credits, setCredits] = useState("");
    
    const [isUpcomingCalls, setIsUpcomingCalls] = useState(1);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    
    const [tabActive, setTabActive] = useState(1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userId } = useParams();

    const { isLoaderFetching, isCallsFetching, userDataFetching, isUserDashboardFetching, isSuccess, isError, errorMessage, particularUser, userUpcomingCalls, userPastCalls, feedback, menteeCallsData, menteePerformance } = useSelector(adminData);

    //Get Months difference
    const getDiff = (param) => {
        return (moment(param).fromNow());
    };
    
    //View Call details Functions
    const handleViewCallDetails = (id) => {
        setViewCallDetails(true);
        dispatch(getFeedbackAnswers(id));
    };

    const handleViewCallClose = () => {
        setViewCallDetails(false);
        setMenteeFeedback({});
        setMentorFeedback({});
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentee", userId, search, date, index: index+1}))
        else dispatch(getPastInterviewDetails({user: "mentee", userId, search, date, status, index: index+1}));
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentee", userId, search, status}))
            else dispatch(getPastInterviewDetails({user: "mentee", userId, search, status}));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentee", userId, search, status}))
            else dispatch(getPastInterviewDetails({user: "mentee", userId, search, status}));
        }
    };

    //Filter functions
    const handleStatusFilter = (status) => {
        setTotalUpcomingcalls([]);
        setTotalPastCalls([]);
        setIndex(1);
        if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentor", userId, status}))
        else dispatch(getPastInterviewDetails({user: "mentor", userId, status}));
    }

    useEffect(() => {
        dispatch(getParticularUser({ user: "mentee", userId }));
        dispatch(getMenteeCallsActivity(userId));
        dispatch(getMenteePerformance(userId));
    }, [])

    useEffect(() => {
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        setIndex(1);
        if(tabActive === 2 && isUpcomingCalls) {
            dispatch(getUpcomingInterviewDetails({user: "mentee", userId}));
        }
        if(tabActive === 2 && !isUpcomingCalls) {
            dispatch(getPastInterviewDetails({user: "mentee", userId}));
        }
    },[tabActive, isUpcomingCalls]);

    //Load more useEffect
    useEffect(() => {
        if(index === 1 && userUpcomingCalls?.calls?.length > 0 ) setTotalUpcomingcalls(userUpcomingCalls?.calls);
        if(index === 1 && userPastCalls?.calls?.length > 0) setTotalPastCalls(userPastCalls?.calls);
        if(index !== 1 && userUpcomingCalls?.calls?.length > 0 ) setTotalUpcomingcalls(prev => [...prev,...userUpcomingCalls?.calls]);
        if(index !== 1 && userPastCalls?.calls?.length > 0) setTotalPastCalls(prev => [...prev,...userPastCalls?.calls]);
    },[userUpcomingCalls,userPastCalls]);

    //View call details useEffect
    useEffect(() => {
        if(feedback?.feedbackAnswers?.length > 0) {
            const menteeArr = feedback?.feedbackAnswers?.filter((item) => item.menteeId);
            const mentorArr = feedback?.feedbackAnswers?.filter((item) => item.mentorId);
            setMenteeFeedback(...menteeArr);
            setMentorFeedback(...mentorArr);
        }
    },[feedback]);

    useEffect(() => {
        if(particularUser) {
            setCredits(particularUser?.credits);
        }
    },[particularUser]);

    useEffect(() => {
        if(isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            dispatch(getParticularUser({ user: "mentee", userId }));
            setTabActive(1);
            dispatch(clearState());
        }
    },[isSuccess]);

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError]);

    return (
        <>
        {isLoaderFetching && <PageLoader />}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
        <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
        <AdviewCallhistory isActive={viewCallDetails} setIsActive={setViewCallDetails} menteeFeedback={menteeFeedback} mentorFeedback={mentorFeedback} callInfo={feedback} handleClose={handleViewCallClose} />
        <section>
            <div className="DashboardWrapper">
                <div className='pathlinkwrapper flex gap-10'>
                    <img src='assets/img/usericons.png' alt="" />
                    <p className='text2' onClick={() => navigate("/admin/all-mentee")}>All Mentees</p>
                    <img src="/assets/img/arrowright.png" alt="" />
                    <p className='text2'>Mentee Profile</p>
                </div>

                <div className="headingprofilewrap mt-30">
                    <h2 className='heading-2'>Profile Overview</h2>
                    {userDataFetching ? <Skeleton width={"150px"} /> : <p className='text3 mt-5'>Joined {getDiff(particularUser?.createdAt)}</p>}
                </div>

                <div className="flex-col Allcardboxwrapper mt-30">
                    <div className="profilewrapper w-100 ">
                        <div className="flex Adprofiledatawrapper">
                            {userDataFetching ? <Skeleton width={"160px"} height={"160px"} /> : <div className='Imageboxall'>
                                <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                            </div>}
                            <div className="AdProfileDetailsarea">
                                <div className="headingwrap">
                                    <div className="headingorg flex gap-10">
                                        <h2 className='heading-2'>{userDataFetching ? <Skeleton width={"200px"} /> : particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                        {particularUser?.linkedin && <a href={particularUser?.linkedin.slice(0,4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' target='_blank' rel='noreferrer'>
                                            <span className='flex gap-2'>
                                                Linkedin
                                                <img src="/assets/img/send.png" alt="" />
                                            </span>
                                        </a>}
                                    </div>
                                    <div className="AdPsnlDetailsMentors mt-10">
                                        {userDataFetching ? <Skeleton width={"100px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/usermentor.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.profession?.title ? particularUser?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                        </div>}
                                        {userDataFetching ? <Skeleton width={"150px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/emailprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                        </div>}
                                        {userDataFetching ? <Skeleton width={"100px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/callprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                    {userDataFetching ?
                                    <div className={`CardContactWrapper`}>
                                    <span className='Adicontoolsicons flex-center'>
                                        {<Skeleton width={"50px"} height={"50px"} circle />}
                                    </span>
                                    <div className="contentareacontact">
                                        <span>{<Skeleton width={"30px"} height={"20px"} />}</span>
                                        <Skeleton width={"100px"} height={"15px"} />
                                    </div>
                                </div>
                                :
                                <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Number of Calls'} img={"/assets/img/yellowcall.png"} />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="AdMenusTabWrapper w-100 mt-40">
                        <ul className='flex gap-30 items-center'>
                            <li onClick={() => setTabActive(1)} className={tabActive === 1 && 'active'}>Overview</li>
                            <li onClick={() => setTabActive(2)} className={tabActive === 2 && 'active'}>Call History</li>
                            <li onClick={() => setTabActive(3)} className={tabActive === 3 && 'active'}>Profile Details</li>
                        </ul>
                    </div>

                </div>

            </div>

            <OverviewMentee isActiveTab={tabActive === 1 && 'active'} callsData={menteeCallsData} performance={menteePerformance} isFetching={isUserDashboardFetching} />
            <CallHistoryMentee isActiveTab={tabActive === 2 && 'active'} handleStatusFilter={handleStatusFilter} handleSearchChange={handleSearchChange} handleSearch={handleSearch} handleSearchPress={handleSearchPress} isFetching={isCallsFetching} isUpcomingCalls={isUpcomingCalls} setIsUpcomingCalls={setIsUpcomingCalls} upcomingCalls={totalUpcomingCalls} pastCalls={totalPastCalls} upcoming={userUpcomingCalls} past={userPastCalls} handleLoadMore={handleLoadMore} onClickViewCallDetails={handleViewCallDetails} />
            <Profiledetails isActiveTab={tabActive === 3 && 'active'} data={particularUser} isFetching={userDataFetching} />

        </section>
        </>
    )
}

export default AdMenteeProfile